import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { HttpModule } from '@angular/http';

// Routing
import { Routing } from './routing/app.routing';

// Modules
import { TranslationModule } from './translation/translation.module';

// Components
import { AppComponent } from './app.component';

// Guards
import { AuthGuard } from './auth/services/auth-guard.service';
import { AnonymousGuard } from './auth/services/anonymous-guard.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    HttpModule,
    RouterModule,
    BrowserModule,
    Routing,
    StoreModule.forRoot({}, {}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 50 }),
    // Custom Modules
    TranslationModule.forRoot(),
    BrowserAnimationsModule
  ],
  providers: [
    AuthGuard,
    AnonymousGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts